import getUUID from "../utils/uuid";

export default class Node {
  parent;
  children = [];
  id;

  // data property
  type = "";
  style = "";
  className = "";
  data;

  constructor({ type, style, className = "", url = "", text = "", data = {}, id, extraComponents}) {
    this.type = type;
    this.style = style;
    this.className = className;
    this.url = url;
    this.text = text;
    this.extraComponents = extraComponents;
    this.data = { ...data };
    this.id = id || getUUID();
  }

  addChild(data, index) {
    const newNode = data instanceof Node ? data : new Node(data);
    if (index !== void(0) && index >= 0) {
      this.children.splice(index, 0, newNode);
    } else {
      this.children.push(newNode);
    }
    newNode.parent = this;
  }

  toJSON(options = { isDuplcate: false }) {
    const { isDuplcate } = options;
    const jsonData = {
      type: this.type,
      style: this.style,
      data: {
        ...this.data,
      },
      className: this.className,
      children: [],
      extraComponents: this.extraComponents,
    };
    if (isDuplcate) {
      delete jsonData.data.contentID;
    } else {
      jsonData.id = this.id;
    }
    this.__buildJSON(this, jsonData, options);
    return jsonData;
  }

  __buildJSON(node, parent, options) {
    const { isDuplcate } = options;
    node.children.forEach((n) => {
      const jsonData = {
        type: n.type,
        style: n.style,
        data: {
          ...n.data,
        },
        className: n.className,
        children: [],
      };
      if (isDuplcate) {
        delete jsonData.data.contentID;
      } else {
        jsonData.id = n.id;
      }
      parent.children.push(jsonData);
      this.__buildJSON(n, jsonData, options);
    });
  }

  findAncestor() {
    let tmpNode = this;
    while(tmpNode.parent) {
      tmpNode = tmpNode.parent;
    }
    return tmpNode;
  }
}
